import uploadOrderFile from '../../../Services/uploadOrderFile';

export default (acceptedFiles: FileList) => async (dispatch) => {

  dispatch(uploadOrderFile(acceptedFiles))
  
}